export const DataLocation = {
    data() {
      return {
        locations: [],
        locationHeaderFilter: []
      }
    },
    methods: {
      getFullPath(id) {
        const item = this.locations.filter(item => item.id === id);
        if (item.length !== 0 && item[0].parent) {
          return this.getFullPath(item[0].parent.id).concat(item);
        } else {
          return item;
        }
      },
    },
}